import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgUnlock = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.864 2a5.65 5.65 0 0 1 4.052 1.69.75.75 0 1 1-1.07 1.051A4.14 4.14 0 0 0 11.868 3.5h-.004a4.23 4.23 0 0 0-4.23 4.23v1.385h9.923c1.2 0 2.173.973 2.173 2.174v8.538c0 1.2-.973 2.173-2.173 2.173H6.173C4.973 22 4 21.027 4 19.827v-8.538c0-1.188.952-2.153 2.135-2.173V7.73A5.73 5.73 0 0 1 11.864 2m-5.69 8.616a.673.673 0 0 0-.674.673v8.538c0 .372.301.673.673.673h11.385a.673.673 0 0 0 .673-.673v-8.538a.673.673 0 0 0-.673-.673zm5.73 4.942a.038.038 0 1 1-.077 0 .038.038 0 0 1 .077 0m-.039-1.462a1.462 1.462 0 1 0 0 2.923 1.462 1.462 0 0 0 0-2.923"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgUnlock;
